import { render, staticRenderFns } from "./PermissionsDialog.vue?vue&type=template&id=a9b2b58e&"
import script from "./PermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports